import { z } from 'zod'

export const RENTAL_STATUS      = ['UPCOMING', 'ACTIVE', 'CLOSING', 'COMPLETED'] as const
export const RENTAL_PERIODICITY = ['MONTHLY', 'QUARTERLY', 'YEARLY'] as const

const moneySchema   = z.string().regex(/^\d+(\.\d{1,2})?$/, 'Invalid amount').max(20)
const isoDateSchema = z.string().datetime({ offset: true })

export const rentalCreateSchema = z.object({
	propertyId:       z.string().min(1),
	tenantContactId:  z.string().min(1).optional(),
	tenantId:         z.string().min(1).optional(),
	dealId:           z.string().min(1).optional(),
	period:           z.enum(RENTAL_PERIODICITY),
	rentAmount:       moneySchema,
	currency:         z.string().length(3),
	startDate:        isoDateSchema,
	endDate:          isoDateSchema.optional(),
	vatPercent:       z.string().regex(/^\d+(\.\d{1,2})?$/).optional(),
	depositAmount:    moneySchema.optional(),
	depositCurrency:  z.string().length(3).optional(),
	penaltyRate:      z.string().regex(/^\d+(\.\d{1,4})?$/).optional(),
	penaltyGraceDays: z.number().int().min(0).max(365).optional(),
}).refine((d) => d.tenantContactId ?? d.tenantId, { message: 'tenantContactId is required' })

export const rentalUpdateSchema = z.object({
	startDate:        isoDateSchema.optional(),
	endDate:          isoDateSchema.optional(),
	rentAmount:       moneySchema.optional(),
	period:           z.enum(RENTAL_PERIODICITY).optional(),
	vatPercent:       z.string().regex(/^\d+(\.\d{1,2})?$/).optional(),
	depositAmount:    moneySchema.optional(),
	penaltyRate:      z.string().regex(/^\d+(\.\d{1,4})?$/).optional(),
	penaltyGraceDays: z.number().int().min(0).max(365).optional(),
})

export const rentalUpdateStatusSchema = z.object({ status: z.enum(RENTAL_STATUS) })

export type RentalCreateInput       = z.infer<typeof rentalCreateSchema>
export type RentalUpdateInput       = z.infer<typeof rentalUpdateSchema>
export type RentalUpdateStatusInput = z.infer<typeof rentalUpdateStatusSchema>
